export var teal = '#00B1C9';
export var tealHover = '#00C8E3';
export var tealSelected = '#142E32';
export var purple = '#9153DA';
export var red = '#EB5050';
export var redAlert = '#2C1D1D';
export var orange = '#F9934B';
export var orangeAlert = '#2E231C';
export var green = '#74B046';
export var greenAlert = '#20261C';
export var blue = '#4D89F2';
export var blueAlert = '#1C222D';
export var grey900 = '#171717';
export var grey800 = '#232323';
export var grey500 = '#B1B1B1';
export var grey400 = '#313131';
export var grey300 = '#3A3A3A';
export var grey100 = '#F3F3F3';